import * as React from 'react';
import { NavLink } from 'react-router-dom';

export interface TabLinkProps {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
  to: string;
}

export const TabLink: React.FC<TabLinkProps> = ({ children, onClick, to }) => (
  <li>
    <NavLink activeClassName="is-active" onClick={onClick} to={to}>
      {children}
    </NavLink>
  </li>
);
